import {GeneralRedirect, IRoutesProvider } from 'Shared/Routes';
import { sharedRoutes } from 'Shared/routes/SharedRoutes';
import { lazy, onMount } from 'solid-js';


export class ArtistRoutes implements IRoutesProvider
{
	routes()
	{
		return ([
			{
				path: '/',
				component: () => <GeneralRedirect url='/login' />
			},
			{
				path: '/login',
				component: lazy(() => import('Shared/users/LoginPage')),
			},
			...sharedRoutes(),

			{
				path: '/',
				component: lazy(() => import('Shared/artists/ArtistWrap')),

				children: [
					{
						path: '/profile/:id',
						component: lazy(() => import('Shared/artists/ProfilePage')),
					},
					{
						path: '/tasks',
						component: lazy(() => import('Shared/artists/TasksPage')),
					},
					{
						path: '/user',
						component: lazy(() => import('Shared/artists/UserPage')),
					},
				]
			},
			{
				path: '/',
				component: lazy(() => import('Shared/artists/ProfilePageStepped/SteppedWrap').then(m => ({default: m.SteppedWrap}))),

				children: [
					{
						path: '/manager',
						component: lazy(() => import('Shared/artists/ManagerPage')),
					},
					{
						path: '/events/:id',
						component: lazy(() => import('Shared/artists/ArtistEventsPage')),
					},
					{
						path: '/profileStepped/new',
						component: lazy(() => import('Shared/artists/NewProfilePage').then(m => ({default: m.NewProfilePage}))),
					},
					{
						path: '/profileStepped/:id',
						component: lazy(() => import('Shared/artists/ProfilePageStepped/ProfilePageStepped').then(m => ({default: m.ProfilePageStepped}))),
					}
				]
			},
			{

				path: '/*',
				component: PageNotFoundPage,
				//NOTE Solid Start has a way to do this built in. Doesn't matter enough to bother with for the moment.
//				code: 400
			}
		]);
	}

//TODO maybe trim trailing / from all...
}

function PageNotFoundPage()
{
	onMount(() => document.body.style.opacity = '1');

	return (
		<p>
			Sorry, no such page.
		</p>
	);
}

